// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import '@/assets/style.css'
import axios from 'axios'
import VueGtag from 'vue-gtag'
import VueCookies from 'vue-cookies'
import 'flag-icons/css/flag-icons.min.css'

// ⚠️ Vue 2 only removidos/substituídos:
// - ValidationObserver/Provider (vee-validate 3) -> vamos migrar para vee-validate 4 nos componentes
// - vue-plyr -> usar vue3-plyr (ver comandos abaixo)
// - vue-flag-icon -> usar só CSS de flag-icons
// - vue-calendly e @growthbunker/vuesocial: verificar mais tarde se há suporte Vue 3; por ora, comentados

// Componentes/Helpers teus
import MyIcon from '@/components/ui/MyIcon.vue'
import getSocialNetwork from './plugins/getSocialNetwork'

// Axios interceptors
axios.interceptors.request.use(
  (config) => {
    config.withCredentials = true
    config.headers['Content-Type'] = 'application/json'
    config.headers['Accept'] = 'application/json'
    return config
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      router.push('/')
    }
    return Promise.reject(error)
  }
)

// Criação da app Vue 3
const app = createApp(App)

// Globais (substitui Vue.prototype)
app.config.globalProperties.$getSocialNetwork = getSocialNetwork

// Componentes globais
app.component('my-icon', MyIcon)

// Plugins
app.use(router)
app.use(vuetify)
app.use(i18n)
app.use(VueCookies, { expires: '7d' })
app.use(VueGtag, {
  config: {
    id: 'G-00YHF67M8C',
    params: { send_page_view: true }
  }
}, router)

// Se fores usar vue3-plyr:
// import VuePlyr from 'vue3-plyr'
// import 'vue3-plyr/dist/vue3-plyr.css'
// app.use(VuePlyr)

app.mount('#app')
